import Swal from "sweetalert2";
import { get_api_error_message } from "./donation_campaigns_form_helper";

function confirm_delete_campaign() {
  return Swal.fire({
    title: "Are you sure?",
    text: "This campaign will be deleted.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    position: "bottom-end",
    toast: true,
  });
}

function get_next_campaign_after_delete(my_campaigns_data, public_campaigns, campaign_id) {
  const next_my_campaign = my_campaigns_data.find((item) => Number(item.id) !== Number(campaign_id)) || null;
  if (next_my_campaign) {
    return next_my_campaign;
  }

  return public_campaigns.find((item) => Number(item.id) !== Number(campaign_id)) || null;
}

function remove_campaign_from_lists(instance, campaign_id) {
  instance.my_campaigns_data = instance.my_campaigns_data.filter((item) => Number(item.id) !== Number(campaign_id));
  instance.public_campaigns = instance.public_campaigns.filter((item) => Number(item.id) !== Number(campaign_id));
}

function show_delete_toast() {
  Swal.fire({
    icon: "success",
    title: "Campaign deleted.",
    showConfirmButton: false,
    timer: 2200,
    position: "bottom-end",
    toast: true,
  });
}

function show_delete_error(message) {
  Swal.fire({
    icon: "error",
    title: message,
    showConfirmButton: false,
    timer: 2500,
    position: "bottom-end",
    toast: true,
  });
}

function handle_delete_success(instance, campaign) {
  remove_campaign_from_lists(instance, campaign.id);
  instance.manage_campaign_id = null;

  const next_campaign = get_next_campaign_after_delete(
    instance.my_campaigns_data,
    instance.public_campaigns,
    campaign.id
  );

  if (Number(instance.selected_campaign_id) === Number(campaign.id)) {
    instance.selected_campaign_id = next_campaign?.id || null;
  }

  if (Number(instance.editing_campaign_id) === Number(campaign.id)) {
    instance.reset_form();
    instance.active_tab = "manage";
  }

  show_delete_toast();
}

function handle_delete_error(error) {
  show_delete_error(get_api_error_message(error, "Unable to delete campaign."));
}

export const campaign_delete_methods = {
  delete_campaign(campaign) {
    if (!campaign || !this.token_exists) {
      return;
    }

    confirm_delete_campaign().then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.is_deleting_campaign_id = campaign.id;
      const form_data = new FormData();
      form_data.append("campaign_id", campaign.id);

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/donation_management/delete_campaign/`,
        method: "DELETE",
        headers: this.get_request_headers(),
        data: form_data,
        processData: false,
        contentType: false,
        success: () => handle_delete_success(this, campaign),
        error: (error) => handle_delete_error(this, error),
        complete: () => {
          this.is_deleting_campaign_id = null;
        },
      });
    });
  },
};
